import { TYPES } from "../actions";

const initialState = {
  designs: [],
  totalCount: 0,
  currentDesign: null,
  loading: false
};

export const tkt1OnmDesignReducer = (state = initialState, action) => {
  switch (action.type) {

    case TYPES.ACTION_GET_TKT1_ONM_DESIGNS_SUCCESS:
      return { 
        ...state, 
        designs: action.payload.data.data || action.payload.data || [], 
        totalCount: action.payload.data.pagination?.total_count > -1 
          ? action.payload.data.pagination.total_count 
          : (action.payload.data.data?.length || action.payload.data?.length || state.totalCount),
        loading: false
      };

    case TYPES.ACTION_GET_TKT1_ONM_DESIGNS_FAIL:
      return { 
        ...state, 
        designs: [],
        loading: false
      };

    case TYPES.ACTION_GET_TKT1_ONM_DESIGN_BY_ID_SUCCESS:
      return { 
        ...state, 
        currentDesign: action.payload.data,
        loading: false
      };

    case TYPES.ACTION_GET_TKT1_ONM_DESIGN_BY_ID_FAIL:
      return { 
        ...state, 
        currentDesign: null,
        loading: false
      };

    case TYPES.ACTION_CREATE_TKT1_ONM_DESIGN_SUCCESS:
      return { 
        ...state, 
        designs: [action.payload.data, ...state.designs],
        totalCount: state.totalCount + 1,
        loading: false
      };

    case TYPES.ACTION_CREATE_TKT1_ONM_DESIGN_FAIL:
      return { 
        ...state, 
        loading: false
      };

    case TYPES.ACTION_UPDATE_TKT1_ONM_DESIGN_SUCCESS:
      return { 
        ...state, 
        designs: state.designs.map(design => 
          design.id === action.payload.data.id ? action.payload.data : design
        ),
        currentDesign: state.currentDesign && state.currentDesign.id === action.payload.data.id 
          ? action.payload.data 
          : state.currentDesign,
        loading: false
      };

    case TYPES.ACTION_UPDATE_TKT1_ONM_DESIGN_FAIL:
      return { 
        ...state, 
        loading: false
      };

    case TYPES.ACTION_DELETE_TKT1_ONM_DESIGN_SUCCESS:
      return { 
        ...state, 
        designs: state.designs.filter(design => design.id !== action.payload.id),
        totalCount: Math.max(0, state.totalCount - 1),
        currentDesign: state.currentDesign && state.currentDesign.id === action.payload.id 
          ? null 
          : state.currentDesign,
        loading: false
      };

    case TYPES.ACTION_DELETE_TKT1_ONM_DESIGN_FAIL:
      return { 
        ...state, 
        loading: false
      };
      
    default:
      return state;
  }
};

